import React from 'react';
import EquipmentSection from './EquipmentSection';

export default function EquipmentFeatures({ features }) {
  if (!features.items.length) return null;
  return <EquipmentSection eyebrow={features.eyebrow} title={features.title}>
    <div className="equipment-features">
      {features.items.map(feature => <article key={feature.id}>
        <h3>{feature.title}</h3>
        <p>{feature.description}</p>
      </article>)}
    </div>
  </EquipmentSection>;
}
